import { useState } from "react";
import CustomNavItem from "../../../components/custom/CustomNavItem";
import Layout from "../../../components/custom/Layout";
import { Nav } from "reactstrap";
import { TabContent } from "reactstrap";
import CustomTabPane from "../../../components/custom/CustomTabPane";
import Main from "./Main";
import Log from "./Log";
import useSWR from "swr";
import { customFetcher } from "../../../utils";

export type Tab = 'PROCEDURES' | 'LOG';

export interface ProcedureLog {
    id: number;
    name: string;
    metaData: string;
    runBy: string;
    date: string;
}

export default function Procedures() {

    const {
        data,
        mutate
    } = useSWR(`/procedures/logs`, customFetcher<ProcedureLog>, {
        fallbackData: []
    });

    const [activeTab, setActiveTab] = useState<Tab>('PROCEDURES');
    const toggleTab = (tab: Tab) => setActiveTab(tab);

    return (
        <Layout>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<Tab>
                    tabName="Procedures"
                    tabId="PROCEDURES"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<Tab>
                    tabName="Log"
                    tabId="LOG"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<Tab> tabId={'PROCEDURES'}>
                    <Main 
                        data={data}
                        mutate={mutate}
                    />
                </CustomTabPane>
                <CustomTabPane<Tab> tabId={'LOG'}>
                    <Log 
                        data={data}
                    />
                </CustomTabPane>
            </TabContent>
        </Layout>
    );
}